<template>
  <div class="select-item-column">
    <v-select
      placeholder="Select Item"
      :value="modelValue"
      @input="itemSelected"
      :options="itemOptions"
      v-if="!switchToManualInput"
    >
    </v-select>
    <input
      v-if="switchToManualInput"
      type="text"
      class="form-control"
      v-model="modelValue"
      @change="itemInputed"
      placeholder="Type new item name"
    />
    <p
      class="input-switcher"
      @click="switchToManualInput = !switchToManualInput"
    >
      {{ switchToManualInput ? "Select Existing Items" : "Create New Item" }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["value", "items"],
  data() {
    return {
      itemOptions: [],
      modelValue: null,
      switchToManualInput: false,
    };
  },

  watch: {
    value: function () {
      this.modelValue = this.value;
    },
  },

  mounted() {
    this.modelValue = this.value;
    this.itemOptions = this.items;
  },

  methods: {
    itemSelected(item) {
      if (item) {
        let index = this.itemOptions.findIndex((x) => x === item);
        if (index === -1) {
          this.itemOptions.push(item);
        }
      }
      this.$emit("input", item);
    },
    async itemInputed(e) {
      const item = e.target.value;
      const formData = new FormData();
      formData.append("name", item);
      if (item) {
        let index = this.itemOptions.findIndex((x) => x === item);
        if (index === -1) {
          try {
            await axios.post("v2/others/accessory_item", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            this.itemOptions.push(item);
            this.$emit("reload", item);
          } catch (error) {
            if (error.response.status === 403) {
              toastr.error(
                "Not authorized, please ensure that you have the required permissions."
              );
            } else {
              toastr.error(
                "There was some errors, please correct and try again, or contact the admins"
              );
            }
          }
        }
      }
      this.$emit("input", item);
    },
  },
};
</script>
<style scoped>
.select-item-column .input-switcher {
  position: absolute;
  left: 20px;
  font-size: 12px;
  color: var(--primary-color);
  cursor: pointer;
}
</style>
